import api from './api';

export function getMenuByRol(rol) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/menu/aplicacion/DIGICREDITO/rol/${rol}`);
}
